import './Progressbar.css'
export default function Progressbar(){
    return (<div className="loading-bar-container">
        <div className="loading-bar" />
    </div>);
}